import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { Profile, StoreType } from './profile';

export enum OnboardingPushContentType {
  video = 'video',
  richText = 'richText',
}

export enum OnboardingPushPageType {
  // app pages
  AppStorefrontHome = 'app:storefront:home',
  AppHome = 'app:home',
  AppDiscovery = 'app:discovery',
  AppShopping = 'app:shopping',
  AppSettings = 'app:settings',
  AppMessages = 'app:messages',
  AppLiveShowHost = 'app:live_show:host',
  AppUpcomingShowHost = 'app:upcoming_show:host',
  AppStorefrontOrders = 'app:storefront:orders',
  AppStorefrontInventory = 'app:storefront:inventory',
  AppStorefrontPopclips = 'app:storefront:popclips',
  AppStorefrontCommentchats = 'app:storefront:commentchats',
  AppCommentchatSetup = 'app:commentchat:setup',
  AppNewCommentchat = 'app:commentchat:new',
  AppStoreInfoSettings = 'app:settings:store_info',
  AppPayoutSettings = 'app:settings:payout',
  AppTaxCodeSettings = 'app:settings:taxcode',
  AppShippingOptions = 'app:settings:shipping_options',
  AppStoreReelSettings = 'app:settings:store_reel',
  AppBusinessLocationSettings = 'app:settings:business_location',
  AppSellerSupport = 'app:seller_support',
  AppGoLive = 'app:go_live',
  AppScheduleShow = 'app:schedule_show',
  AppUploadPopclip = 'app:popclip:new',
  AppSellerReferrals = 'app:seller:referrals',
  AppSellerHowTo = 'app:seller:how-to',

  // seller dashboard pages.
  SellerDashboardHome = 'seller_dashboard:home',
  SellerDashboardStoreInfo = 'seller_dashboard:store_info',
  SellerDashboardPopStore = 'seller_dashboard:pop_store',
  SellerDashboardInventory = 'seller_dashboard:inventory',
  SellerDashboardDropshipCatalog = 'seller_dashboard:dropship_catalog',
  SellerDashboardCollections = 'seller_dashboard:collections',
  SellerDashboardOrders = 'seller_dashboard:orders',
  SellerDashboardStorefrontOrders = 'seller_dashboard:orders:storefront',
  SellerDashboardReplayOrders = 'seller_dashboard:orders:replay',
  SellerDashboardOrderItems = 'seller_dashboard:order_items',
  SellerDashboardFulfillment = 'seller_dashboard:fulfillment',
  SellerDashboardShipping = 'seller_dashboard:shipping',
  SellerDashboardPickups = 'seller_dashboard:pickups',
  SellerDashboardPickupDetail = 'seller_dashboard:pickup_detail',
  SellerDashboardOrderDetail = 'seller_dashboard:order_detail',
  SellerDashboardFulfillmentSettings = 'seller_dashboard:fulfillment:settings',
  SellerDashboardPayout = 'seller_dashboard:finance:payout',
  SellerDashboardSalesTax = 'seller_dashboard:finance:sales_tax',
  SellerDashboardCustomers = 'seller_dashboard:customers',
  SellerDashboardCustomerReviews = 'seller_dashboard:customer_reviews',
  SellerDashboardCommentchat = 'seller_dashboard:commentchat',
  SellerDashboardAddProduct = 'seller_dashboard:product:new',
  SellerDashboardEditProduct = 'seller_dashboard:product:edit',
  SellerDashboardShopifySync = 'seller_dashboard:shopify_sync',
  SellerDashboardLiveShows = 'seller_dashboard:live_shows',
  SellerDashboardLiveShow = 'seller_dashboard:live_show',
  SellerDashboardScheduleShow = 'seller_dashboard:schedule_show',
  SellerDashboardReferrals = 'seller_dashboard:referrals',
  SellerDashboardCoupons = 'seller_dashboard:coupons',
  SellerDashboardBadges = 'seller_dashboard:badges',
  SellerDashboardSettings = 'seller_dashboard:settings',
  SellerDashboardContactSupport = 'seller_dashboard:contact_support',
}

// /onboardingPushes/{id}
export interface OnboardingPush extends ModelBase {
  title: string;
  summary: string;
  subjectLine: string;
  subtitle: string;
  editor: string;
  embedCode: string;
  contentType: OnboardingPushContentType;
  cover?: string;
  videoUrl?: string;
  videoSize?: {
    width: number;
    height: number;
  };
  // this takes precedence over appearOnSpecificPages
  appearOnAllScreens?: boolean;
  appearOnSpecificPages?: string[];
  visibleTo: StoreType[];
  buttonDelayInSeconds: number;
  startTime: AppDate;
  totalViewers: number;
  // if true, no longer show this push
  disabled: boolean;
  // flow: false(draft) -> true(published). cannot be set to false again
  published?: boolean;
  // mainly for testing purpose
  // if defined, this push will only be applied to these sellers
  sellerIds?: string[];
  historySellerIds?: string[];
  // defines a simple action button
  cta?: {
    title: string; // button text/title
    link: string; // any arbitrary link
  };
  notification?: {
    title: string;
    body?: string;
  };
}

// /stores/{storeId}/onboardingPushes/{id}
// shares the same doc id as /onboardingPushes/{id}
export interface StoreOnboardingPush extends ModelBase {
  // true if the seller has viewed this push
  viewed: boolean;
  viewedAt?: AppDate;
  disabled: boolean;
  profile: Profile;
}
